// A guide can have a link of its own per language: the translation
// `<label> [url]` of that language holds it. A language without one gets the
// link of the application configuration.
export const localizedUrl = (messages, label, url) => {
  const own = messages?.[`${label} [url]`];

  return typeof own === 'string' && own.startsWith('https://') ? own : url;
};
